import { href } from 'react-router-dom';
import '../css/style.css';
import '../css/header.css'
import logo from '../img/logo.svg';

import { Navbar, Nav, Dropdown, Button, Container } from "react-bootstrap";

const defaultUser = "Шевченко Т. Г.";
const TEXT_AUTH = "Увійти";
const TEXT_OUT = "Вийти";

const typesRoles = [
  { role: 'superadmin', label: "Кабінет адміністратора системи", href: "cabinetdou" }, 
  { role: 'specialist', label: "Кабінет спеціаліста ДОН", href: "cabinetdou" },
  { role: 'admin', label: "Кабінет адміністратора ДОН", href:"cabinetdou" }, 
  { role: 'moderator', label: "Кабінет модератора", href:"cabinetdou" }, 
  { role: 'kindergartenHead', label: "Кабінет керівника ЗДО", href:"cabinetheadkg" },
  { role: 'nurse', label: "Кабінет медичної сестри ЗДО", href:"cabinetheadkg" },
  { role: 'techassistance', label: "Кабінет технічної підтримки", href:"cabinetdou" },
  { role: 'kindergartenHead', role_main: ["superadmin", "specialist", "admin"], 
            label: "Режим редагування ЗДО", href:"cabinetheadkg", isExitPossible: false }, 
  { role: 'kindergartenHead', role_main: ["moderator"], 
            label: "Режим перегляду ЗДО", href:"cabinetheadkg",  isExitPossible: false },

]

const findObject = (B, A) => A.find(item => 
  B.role_main 
    ? item.role_main?.includes(B.role_main) && item.role === B.role 
    : item.role === B.role && !item.role_main
);

const isShowExitFromCabinet = (roles, arr_roles)=>{

  for(let r of roles.filter(r_=>r_.isSecondRole)){
    for(let f of arr_roles.filter(af_=>af_.hasOwnProperty("role_main") && af_.role_main.includes(r.role_main))){
      if(f.role == r.role && f.hasOwnProperty("isExitPossible") && !f.isExitPossible) return false; 
    }
  }

  return true;

}

function Header({ state, user, onLogin, onLogout, privelegedlist = [], fullWidth = false , showMenu, firstpage}) {

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
  };

  const navbarContent = (
    <>
      <Navbar.Brand href="/" className={fullWidth ? "navbar-brand-custom" : ""}>
        <img src={logo} alt="Логотип Дитячі садочки Києва" />
      </Navbar.Brand>
      
      <Navbar.Toggle aria-controls="navbarNav" />
      
      <Navbar.Collapse id="navbarNav" className={fullWidth ? "navbar-collapse-wide" : ""}>
        {<Nav className={fullWidth ? "navbar-nav-wide" : "mx-auto"} style={{visibility: showMenu ? 'visible': 'hidden'}}>
          <Nav.Link href="/reqlists">Всі заявки</Nav.Link>
          <Nav.Link href="/kglist">Всі садочки</Nav.Link>
          <Nav.Link href="https://portal.kyiv.digital/service/oplata-kharchuvannya-v-dytyachomu-sadochku">Сплатити за харчування</Nav.Link>
          <Nav.Link href="/publicstatistics">Статистика</Nav.Link>
        </Nav>}
        
        {state == "authsuccess" ? (
          <Dropdown align="end" className={`user-dropdown ${fullWidth ? "ms-auto" : ""}`}>
            <Dropdown.Toggle as={Nav.Link} className="d-flex align-items-center">
                    <i className="fa-solid fa-user-circle me-2"></i>
                    {user || defaultUser}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="/profile">Кабінет батьків</Dropdown.Item>
                    {privelegedlist.map((p, index) => {
                      const desc = findObject(p, typesRoles);
                      if (desc) return <Dropdown.Item key={index} href={"/"+desc.href}>{desc.label}</Dropdown.Item>
                      return null;
                    })}
                    {isShowExitFromCabinet(privelegedlist, typesRoles) && <><Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout}>
                      {TEXT_OUT}
                    </Dropdown.Item></>}
                  </Dropdown.Menu>
          </Dropdown>
        ) : (
          <Button 
            variant="outline-primary" 
            onClick={onLogin}
            className={`login-button ${fullWidth ? "ms-auto" : ""}`}
          >
            <i className="fa-solid fa-right-to-bracket me-2"></i>
            {TEXT_AUTH}
          </Button>
        )}
      </Navbar.Collapse>
    </>
  );

  return (
    <header className={false && firstpage ? "header transparent": "header"}>
      <Navbar expand="lg" className={fullWidth ? "navbar-full-width" : ""}>
        {fullWidth ? (
          <Container fluid className="navbar-wide-container">
            {navbarContent}
          </Container>
        ) : (
          <Container>
            {navbarContent}
          </Container>
        )}
      </Navbar>
    </header>
  );
}

export default Header;